import { WindTurbineCheckIcon } from './WindTurbineCheckIcon';

/**
 * author: Michael Irigoyen
 * id 6B86211C-130B-4A90-A9C7-9B58A5228D30
 * name wind-turbine-check
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wind-turbine-check.svg
 * tags
 * - Home Automation 
 */
export const WindPowerSuccessIcon = WindTurbineCheckIcon;
export default WindPowerSuccessIcon